var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvailability(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#EA2E18",
    d: "M45 32c-5.522 0-10-4.477-10-10 0-5.522 4.478-10 10-10M33 22h12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EA2E18",
    d: "M42 43c11.597 0 21-9.402 21-21S53.597 1 42 1s-21 9.402-21 21 9.403 21 21 21z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#373737",
    d: "M17 37c0 1.53.89 2.907 2.249 3.474l5.507 2.305c1.59.67 2.504 2.426 2.179 4.186-.326 1.761-1.799 3.034-3.514 3.035h-5.42M21.5 54v-4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#373737",
    d: "M14.243 21A21.889 21.889 0 0 0 1.202 44.064a21.886 21.886 0 0 0 18.736 18.735A21.888 21.888 0 0 0 43 49.754"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#373737",
    fillRule: "nonzero",
    d: "M13.848 20.081A22.889 22.889 0 0 0 .211 44.2a22.886 22.886 0 0 0 19.592 19.59A22.888 22.888 0 0 0 43.92 50.15a1 1 0 1 0-1.838-.79 20.888 20.888 0 0 1-22.008 12.449 20.886 20.886 0 0 1-17.88-17.88 20.89 20.89 0 0 1 12.445-22.01 1 1 0 0 0-.79-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#373737",
    fillRule: "nonzero",
    d: "M17 36a1 1 0 0 1 1 1c0 1.132.653 2.142 1.635 2.552l5.509 2.306c2.03.855 3.184 3.073 2.774 5.289-.412 2.228-2.292 3.852-4.497 3.853h-.92v3a1 1 0 0 1-.884.993L21.5 55a1 1 0 0 1-1-1v-3H18a1 1 0 0 1-.993-.883L17.001 50a1 1 0 0 1 1-1h5.42c1.169 0 2.193-.84 2.493-2.043l.037-.174c.241-1.304-.432-2.596-1.582-3.081l-5.506-2.305C17.128 40.672 16 38.929 16 37a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB2F16",
    fillRule: "nonzero",
    d: "M42 44c12.15 0 22-9.85 22-22S54.15 0 42 0 20 9.85 20 22s9.85 22 22 22zm0-2c-11.045 0-20-8.955-20-20S30.955 2 42 2s20 8.955 20 20-8.955 20-20 20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB2F16",
    fillRule: "nonzero",
    d: "M45 11a1 1 0 0 1 0 2c-4.632 0-8.448 3.5-8.945 8H45a1 1 0 0 1 0 2h-8.945c.498 4.5 4.313 8 8.945 8a1 1 0 0 1 0 2c-5.738 0-10.45-4.393-10.955-10H33a1 1 0 1 1 0-2h1.045C34.55 15.394 39.262 11 45 11z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailability);
export default __webpack_public_path__ + "static/media/availability.a16babb203664c7411d20e4439a144a6.svg";
export { ForwardRef as ReactComponent };